import { Badge } from "@/components/ui/badge";
import { Clock, CheckCircle2, XCircle } from "lucide-react";

const MAP = {
  pending: { label: "Pending", cls: "bg-warning/10 text-warning border-warning/30", Icon: Clock },
  approved: { label: "Approved", cls: "bg-success/10 text-success border-success/30", Icon: CheckCircle2 },
  rejected: { label: "Rejected", cls: "bg-danger/10 text-danger border-danger/30", Icon: XCircle },
};

export function StatusBadge({ status }) {
  const cfg = MAP[status] || MAP.pending;
  const { Icon } = cfg;
  return (
    <Badge
      variant="outline"
      data-testid={`status-badge-${status}`}
      className={`rounded-full gap-1 font-medium ${cfg.cls}`}
    >
      <Icon className="h-3 w-3" />
      {cfg.label}
    </Badge>
  );
}
